import React, { useState } from 'react';
import './style.scss';
import AuthLayout from './auth-layout';
import { Link, useNavigate } from 'react-router-dom';
import { Input } from '@cokitchen/cokitchen-components';
import AuthService from 'services/auth.service';
import { ROUTE_KEYS } from 'utils/constants';
import { getLocationOrigin, handleApiError, isValidEmail } from 'utils/functions';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '' });
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    const payload = {
      dashboard_link: getLocationOrigin() + '/auth/reset-password',
      email: formData.email
    };
    try {
      setLoading(true);
      const res = await AuthService.forgotPassword(payload);
      if (res?.status === 201) {
        navigate(`/${ROUTE_KEYS.AUTH}/${ROUTE_KEYS.CONFIRM_MAIL}`, {
          state: {
            email: formData.email
          }
        });
      }
    } catch (err) {
      handleApiError(err);
    }
    setLoading(false);
  };
  return (
    <div>
      <AuthLayout
        title='Forgot Password?'
        disabled={!isValidEmail(formData.email)}
        onConfirm={handleConfirm}
        loading={loading}
        subtitle='Enter the email, you signed up with, we will send you a link to create a new password'
        subText={
          <p className='text-[#6F7376] mt-4'>
            Remember your password?{' '}
            <Link
              className='cursor-pointer ml-1 text-[#2E3031] font-medium '
              to={`/${ROUTE_KEYS.AUTH}/${ROUTE_KEYS.LOGIN}`}>
              Login
            </Link>
          </p>
        }>
        <Input
          design='bordered'
          placeholder='Email'
          label='Email'
          type='email'
          value={formData.email}
          onChange={(e) => setFormData({ email: e.target.value })}
        />
      </AuthLayout>
    </div>
  );
};

export default ForgotPassword;
